import React from 'react';
import { Table } from 'new/elements/Table';
import { columns } from './columns';

interface ResourcesTableProps {}

export function ResourcesTable(props: ResourcesTableProps) {
  return <Table height={400} columns={columns} rows={[]} />;
}
